export function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
export function dataFormater(number: number, decimalScale?: number) {
  let dec = decimalScale ? decimalScale : 2;
  if (number > 1000000000) {
    return (number / 1000000000).toFixed(dec) + "B";
  } else if (number > 1000000) {
    return (number / 1000000).toFixed(dec) + "M";
  } else if (number > 1000) {
    return (number / 1000).toFixed(dec) + "K";
  } else {
    return number.toFixed(dec).toString();
  }
}
export function convertToInternationalCurrencySystem(
  labelValue: number,
  decimalScale?: number
) {
  // Nine Zeroes for Billions
  return Number.isNaN(labelValue)
    ? ""
    : Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(decimalScale) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
        : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(decimalScale) + "K"
          : Math.abs(Number(Number(labelValue).toFixed(decimalScale)));
}

export function formatNumberWithCommas(number: number): string {
  const numStr = number.toString();
  const parts = numStr.split(".");
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedNumber =
    parts.length > 1 ? integerPart + "." + parts[1] : integerPart;
  return formattedNumber;
}

export function formatAddress(address: string, number = 4) {
  return (
    address && `${address.substr(0, number + 2)}...${address.substr(-number)}`
  );
}

export function toPlainString(num: number) {
  return ("" + +num).replace(
    /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
    function (a, b, c, d, e) {
      return e < 0
        ? b + "0." + Array(1 - e - c.length).join("0") + c + d
        : b + c + d + Array(e - d.length + 1).join("0");
    }
  );
}
export const isBSCChain = (chainId: number) => {
  return [56, 97].includes(chainId);
};
export const isArbiChain = (chainId: number) => {
  return [42161, 421611, 421613].includes(chainId);
};
export const isZkSync = (chainId: number) => {
  return [324, 280].includes(chainId);
};
export const isLinea = (chainId: number) => {
  return [59140, 59144].includes(chainId);
};

export const isPolygon = (chainId: number) => {
  return [1101].includes(chainId);
};
export const isEthereum = (chainId: number) => {
  return [1].includes(chainId);
};
export const isScroll = (chainId: number) => {
  return [534352].includes(chainId);
}
export const isManta = (chainId: number) => {
  return [169].includes(chainId);
};

export const isBlast = (chainId: number) => {
  return [81457].includes(chainId);
}
export const netWorkName = (chainId: number): string => {
  let text = "";
  if (isBSCChain(chainId)) {
    text = "BNB Chain";
  } else if (isPolygon(chainId)) {
    text = "Polygon zkEVM";
  } else if (isEthereum(chainId)) {
    text = "Ethereum";
  } else if (isArbiChain(chainId)) {
    text = "Arbitrum";
  } else if (isZkSync(chainId)) {
    text = "zkSync Era";
  } else if (isLinea(chainId)) {
    text = "Linea"
  } else if (isScroll(chainId)) {
    text = "Scroll"
  } else if (isManta(chainId)) {
    text = "Manta Pacific"
  } else if (isBlast(chainId)) {
    text = "Blast"
  }
  return text;
};
